export default {
  // Navbar
  nav: {
    howItWorks: 'How it works',
    newUpload: 'New upload',
    signInSave: 'Sign in to save',
    upload: 'Upload',
    files: 'Files',
    account: 'Account',
    signOut: 'Sign out',
    pricing: 'Pricing',
    legal: 'Legal',
    goToApp: 'Go to App',
    signInGoogle: 'Sign in with Google',
  },

  // Landing
  landing: {
    formatsTitle: 'Opens 70 file types',
    formatsLink: 'See every format',
    eyebrow: '3D viewer for Revit, IFC, STEP and 70 file types',
    ctaUpload: 'New upload',
    ctaNoAccount: 'No sign-up needed to try it',
    viewerCaption: 'Live IFC model · drag to orbit',
    heroTitle1: 'BIM file sharing.',
    heroTitle2: 'Simple and fast.',
    heroSubtitle: 'Open Revit, IFC, STEP, Tekla, Rhino, DXF, OBJ, FBX, STL and many more 3D files in the browser. Share them with a link or embed the viewer in your website.',
    heroFree: 'Free — 10 files per month',
    footerRights: 'All rights reserved.',
  },

  // Upload
  upload: {
    bundled: 'Packed {count} files into {name}',
    bundleHint: 'Model with materials or textures (OBJ + MTL, DAE, 3DS…)? Drop the whole folder or a ZIP.',
    guestNotice: 'Guest mode: up to {limit} files. Sign in to keep them and share links.',
    openViewer: 'Open viewer',
    title: 'Upload Files',
    uploadsThisMonth: 'uploads this month',
    remaining: 'remaining',
    dragDrop: 'Drag & drop files here',
    orClick: 'or click to browse',
    formats: 'IFC, DWG, PDF, DXF, BCF, GLTF, GLB, OBJ, FBX, DAE, STL, 3MF, PLY, USDZ and any other file type',
    limitReached: 'Monthly limit reached',
    limitReachedDesc: "You've used all {limit} uploads for this month.",
    upgradePro: 'Upgrade to Pro →',
    uploading: 'Uploading...',
    uploadComplete: 'Upload complete!',
    filesUploaded: '{count} file(s) uploaded successfully.',
    viewMyFiles: 'View my files',
    uploadMore: 'Upload more',
    uploadFailed: 'Upload failed',
    tryAgain: 'Try again',
    limitError: 'Monthly upload limit reached. Upgrade to Pro for more uploads.',
    partialUpload: 'You can only upload {max} more file(s) this month. Uploading first {max}.',
    fileTooLarge: '"{name}" exceeds the {limit} file size limit for your plan. Upgrade to Pro for larger files.',
  },

  // Files
  files: {
    title: 'My Files',
    uploadFiles: 'Upload files',
    loading: 'Loading your files...',
    noFiles: 'No files yet',
    noFilesDesc: 'Upload your first file to get started.',
  },

  // Account
  account: {
    title: 'Account',
    profile: 'Profile',
    userId: 'User ID',
    authProvider: 'Auth Provider',
    subscription: 'Subscription',
    currentPlan: 'Current Plan',
    monthlyLimit: 'Monthly Upload Limit',
    price: 'Price',
    free: 'Free',
    filesPerMonth: '{count} files / month',
    unlimited: 'Unlimited',
    freeForever: '0€ / forever',
    custom: 'Custom',
    viewPlans: 'View plans & upgrade →',
    upgradeToPro: 'Upgrade to Pro',
    manageSubscription: 'Manage subscription',
    processing: 'Processing...',
    usageTitle: "This Month's Usage",
    filesUploaded: 'files uploaded this month',
    unlimitedRemaining: 'Unlimited uploads remaining',
    uploadsRemaining: '{count} upload(s) remaining this month',
    limitReached: 'Monthly limit reached. Resets next month.',
    session: 'Session',
    signOutDesc: 'Sign out of your account on this device.',
    signOut: 'Sign out',
  },

  // Account: Claude / MCP API keys
  mcp: {
    title: 'Claude (MCP)',
    serverUrl: 'MCP server URL',
    desc: 'Use BimDrop from Claude: ask it to upload files, list them and create share links.',
    keyName: 'Key name',
    keyNamePlaceholder: 'Key name, e.g. Claude Code',
    create: 'Create key',
    newKeyWarning: 'Copy this key now. You will not see it again.',
    claudeCode: 'Claude Code',
    otherClients: 'Other MCP clients (JSON config)',
    copy: 'Copy',
    copied: 'Copied',
    created: 'created {date}',
    lastUsed: 'last used {date}',
    neverUsed: 'never used',
    revoke: 'Revoke key',
    revokeConfirm: 'Revoke "{name}"? Claude will lose access with this key.',
    error: 'Something went wrong. Try again.',
    claudeApps: 'claude.ai and Claude Desktop',
    claudeAppsSteps: 'Go to Settings → Connectors → Add custom connector, paste the URL above and sign in with Google.',
    claudeCodeSteps: 'Then run /mcp in Claude Code and sign in with Google.',
    connectedApps: 'Connected apps',
    connected: 'connected {date}',
    disconnect: 'Disconnect',
    disconnectConfirm: 'Disconnect "{name}"? It will lose access to your files.',
    apiKeys: 'API keys',
    apiKeysDesc: 'For scripts and MCP clients without sign-in. Send the key as "Authorization: Bearer …".',
  },

  // OAuth consent page (Claude connectors)
  oauth: {
    loading: 'Checking the request…',
    invalid: 'This connection request is not valid',
    error: 'Something went wrong. Try again.',
    title: 'Allow {app} to access your BimDrop account?',
    unverified: 'BimDrop has not verified this app. Only continue if you trust it.',
    signInPrompt: 'Sign in to continue.',
    signedInAs: 'Signed in as {email}.',
    switchAccount: 'Use another account',
    permissionsTitle: 'It will be able to:',
    permUpload: 'Upload files to your account',
    permList: 'See your files and their links',
    permShare: 'Create and revoke share links',
    redirectNote: 'After you allow it, you will return to {host}.',
    allow: 'Allow',
    deny: 'Cancel',
    redirecting: 'Returning to {host}…',
  },

  // Viewer
  viewer: {
    loadingModel: 'Loading 3D model…',
    loadError: 'Could not load model',
    back: 'Back',
    fitView: 'Fit view',
    projection: 'Projection',
    hideSelected: 'Hide selected element',
    isolateSelected: 'Isolate selected element',
    showAll: 'Show all elements',
    share: 'Share',
    loading: 'Loading file data...',
    processingBtlx: 'Processing BTLx...',
    backToFiles: 'Back to files',
    notPreviewable: 'This file type cannot be previewed.',
    btlxProcessing: 'The 3D model is being generated. Please wait a moment and refresh.',
    btlxError: 'Processing failed. The 3D model could not be generated.',
    btlxQueued: 'The 3D model is queued for processing. Please check back shortly.',
    parts: 'parts',
    layers: 'layers',
  },

  // Shared Viewer
  shared: {
    loading: 'Loading shared model...',
    linkNotFound: 'Link not found',
    linkExpired: 'This shared link does not exist or has expired.',
    goToBimdrop: 'Go to Bimdrop',
    sharedVia: 'This file has been shared with you via Bimdrop.',
    download: 'Download',
    tryFree: 'Try Bimdrop free →',
    hideSelected: 'Hide selected',
    isolateSelected: 'Isolate selected',
    showAll: 'Show all',
  },

  // FileCard
  fileCard: {
    generating3D: 'Generating 3D model...',
    processingFailed: 'Processing failed',
    queued: 'Queued for processing',
    downloadTooltip: 'Download',
    shareTooltip: 'Share',
    editTooltip: 'Edit',
    deleteTooltip: 'Delete',
    confirmDelete: 'Click again to confirm',
    confirm: 'Confirm?',
    view2D: 'View 2D',
    view3D: 'View 3D',
    fileName: 'File name',
    description: 'Description',
    descriptionPlaceholder: 'Add a description...',
    save: 'Save',
    cancel: 'Cancel',
  },

  // Share Modal
  shareModal: {
    shareTitle: 'Share "{name}"',
    viewer: 'Viewer',
    embed: 'Embed',
    shareFile: 'Share File',
    viewerDesc: 'Share a viewer link. Anyone with this link can view or download the file in their browser — no account needed.',
    generatingLink: 'Generating secure link...',
    tryAgain: 'Try again',
    copied: 'Copied!',
    copy: 'Copy',
    recipientsCanView: 'Recipients can view or download the file directly',
    email: 'Email',
    whatsapp: 'WhatsApp',
    embedDesc: 'Paste this code into your website\'s HTML to embed an interactive viewer:',
    generatingEmbed: 'Generating embed code...',
    directLinkDesc: 'Copy the direct download link or send it via email / WhatsApp:',
  },

  // Guest (anonymous) sessions
  guest: {
    badge: 'Guest',
    saveTitle: 'Save your files',
    saveDesc: 'You are using a guest session. Sign in with Google to keep your files and share them.',
    shareLocked: 'Sign in to share',
    shareLockedDesc: 'Public links and embeds need an account. Your uploaded files move to your account.',
    accountDesc: 'Guest session. Your files are lost if you clear browser data or sign out.',
  },

  // Theme toggle
  theme: {
    system: 'Theme: system',
    light: 'Theme: light',
    dark: 'Theme: dark',
  },

  // Cookie Banner
  cookies: {
    message: 'We use cookies to improve your experience. By using Bimdrop, you agree to our',
    cookiePolicy: 'cookie policy',
    accept: 'Accept',
  },

  // Pricing
  pricing: {
    title: 'Simple, transparent pricing',
    subtitle: 'Start free. Upgrade when you need more.',
    free: 'Free',
    pro: 'Pro',
    enterprise: 'Enterprise',
    forever: 'forever',
    perMonth: '/month',
    freeDesc: 'Perfect for getting started',
    proDesc: 'For professionals and small teams',
    enterpriseDesc: 'For organizations with advanced needs',
    getStarted: 'Get started',
    comingSoon: 'Coming soon',
    upgrade: 'Upgrade to Pro',
    processing: 'Processing...',
    contactUs: 'Contact us',
    popular: 'Popular',
    // Features
    freeF1: '10 file uploads per month',
    freeF2: 'Share via link, email & WhatsApp',
    freeF3: 'Embed files on websites',
    freeF4: 'Basic file management',
    freeF5: '100 MB max file size',
    proF1: '150 file uploads per month',
    proF2: 'Everything in Free',
    proF3: '1 GB max file size',
    proF4: 'Custom branding on embeds',
    proF5: 'Priority support',
    proF6: 'Analytics & download tracking',
    entF1: 'Everything in Pro',
    entF2: 'Unlimited file size',
    entF3: 'SSO & team management',
    entF4: 'Custom domain',
    entF5: 'SLA & dedicated support',
    entF6: 'API access',
    home: 'Home',
    legalCookies: 'Legal & Cookies',
  },

  // Legal
  legal: {
    title: 'Legal & Cookie Policy',
    lastUpdated: 'Last updated: March 2026',
  },

  // How it works page
  how: {
    fmtTekla: 'Tekla Structures 2020+ models: upload the model folder as a ZIP (beta)',
    fmtFab: 'Fabrication files: timber (BTLX) and steel parts (DSTV NC1)',
    exportTitle: 'Export from your software',
    exportNote: 'Menu names change slightly between versions.',
    exportRevit1: 'Revit 2023–2025 projects open directly: upload the .rvt (beta).',
    exportRevit2: 'For the full model or other versions: File → Export → IFC.',
    exportRevit3: 'Pick IFC4 Reference View or IFC 2x3 Coordination View 2.0 and upload the .ifc.',
    exportTekla1: 'Model: File → Export → IFC, export type “Coordination view”, then upload the .ifc.',
    exportTekla2: 'Fabrication: Manufacturing → NC files (DSTV). Upload the .nc1 files or a ZIP of the folder.',
    exportTekla3: 'Each NC1 opens as a steel part with its profile, holes and part mark.',
    fmtRvt: 'Revit 2023–2025 projects, converted in your browser (beta)',
    fmtCad: 'Solid CAD: assemblies with names and colours',
    fmtMore: 'X, OFF, 3DS, PLY, VRML, CityJSON and more. DWG and PDF are stored for download.',
    eyebrow: 'How it works',
    title: 'From file to shareable link in three steps',
    subtitle: 'Drop a BIM or CAD file, explore it in 3D in the browser and send a link. No plugins, nothing to install.',
    s1Title: 'Drop your file',
    s1Desc: 'Drag a file onto the upload area or pick it from your computer. You can try it without an account.',
    s1P1: 'IFC, DXF, GLB, OBJ, FBX, DAE, STL, 3MF, USDZ, BTLX, DWG, PDF and more',
    s1P2: 'Up to 100 MB on Free and 1 GB on Pro',
    s1P3: 'No sign-up needed for your first files',
    s2Title: 'Explore it in 3D',
    s2Desc: 'The model opens straight in the browser. Orbit around it, click an element to read its properties, hide or isolate parts.',
    s2P1: 'IFC attributes and property sets',
    s2P2: 'DXF drawings in 2D, GLB, GLTF and STL in 3D',
    s2P3: 'BTLX timber files converted to 3D automatically',
    s3Title: 'Share a link',
    s3Desc: 'Sign in with Google to get a public link. Anyone can open the viewer, no account needed.',
    s3P1: 'Copy the link or send it by email or WhatsApp',
    s3P2: 'Embed the viewer in your website with one snippet',
    s3P3: 'Link previews show a thumbnail of your model',
    mockReady: 'Ready',
    mockSelected: 'Selected',
    mockSite: 'Your website',
    accountsTitle: 'With or without an account',
    guestTitle: 'Without an account',
    guestDesc: 'Perfect to try Bimdrop with your own file.',
    guestF1: '3 uploads, up to 100 MB each',
    guestF2: 'View in 3D and 2D',
    guestF3: 'Files stay in this browser only',
    accountTitle: 'With a free Google account',
    accountDesc: 'Keep your files and share them.',
    accountF1: '10 uploads per month',
    accountF2: 'Public links and embeds',
    accountF3: 'Your files on every device',
    formatsTitle: 'Supported formats',
    fmtIfc: '3D model with properties',
    fmtDxf: '2D drawing, or 3D when it has 3D entities',
    fmtGlb: '3D model, including SketchUp and 3D-printing exports',
    fmtBtlx: 'Timber machining data, converted to 3D',
    fmtOther: 'Stored and shared for download',
    ctaTitle: 'Try it with your own file',
  },

  // Viewer workspace (toolbar, panels, saved views)
  ws: {
    frame: 'Units and orientation',
    units: 'Model units',
    upAxis: 'Vertical axis',
    upY: 'Y up',
    upZ: 'Z up',
    toolSelect: 'Select',
    toolMeasure: 'Measure',
    toolNote: 'Add note',
    toolClip: 'Section',
    fit: 'Fit view',
    presets: 'Views',
    presetIso: 'Isometric',
    presetTop: 'Top',
    presetFront: 'Front',
    presetBack: 'Back',
    presetLeft: 'Left',
    presetRight: 'Right',
    projection: 'Perspective / orthographic',
    walk: 'Walk mode',
    walkHint: 'Drag to look around · WASD or arrows to move · Esc to exit',
    hide: 'Hide',
    isolate: 'Isolate',
    showAll: 'Show all',
    color: 'Colour',
    clearColors: 'Remove colours',
    xray: 'X-ray',
    screenshot: 'Screenshot',
    fullscreen: 'Full screen',
    exitFullscreen: 'Exit full screen',
    clipX: 'Section X',
    clipY: 'Section Y',
    clipZ: 'Section Z',
    clipFace: 'Click a face to cut',
    clipClear: 'Remove sections',
    panel: 'Panel',
    panelModel: 'Model',
    panelCategories: 'Categories',
    panelLayers: 'Layers',
    panelViews: 'Views',
    panelNotes: 'Notes',
    panelMeasures: 'Measurements',
    panelProperties: 'Properties',
    treeLoading: 'Loading structure…',
    treeEmpty: 'No structure available',
    groupsEmpty: 'Nothing to show',
    viewsAdd: 'Save current view',
    viewsNamePlaceholder: 'View name',
    viewsEmpty: 'Save camera positions to guide whoever opens the link.',
    viewDefaultName: 'View {n}',
    notesEmpty: 'Use the note tool to pin comments on the model.',
    notePlaceholder: 'Write a note…',
    noteAdd: 'Add note',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    saveEdit: 'Save',
    measuresEmpty: 'Use the measure tool and click two points.',
    measureClear: 'Clear all',
    measureHint: 'Click two points to measure · Esc to cancel',
    noteHint: 'Click on the model to place a note',
    clipHint: 'Click a face to add a section · drag the arrows to move it',
    selectionEmpty: 'Select an element to see its properties',
    focus: 'Focus',
    save: 'Save view',
    saving: 'Saving…',
    saved: 'View saved',
    saveError: 'Could not save the view',
    tooBig: 'This view is too big to save. Remove some hidden elements or notes.',
    unsaved: 'Unsaved changes',
    resetShared: 'Back to shared view',
    discard: 'Discard changes',
    ownerHint: 'What you save here is what people see on the shared link.',
    sharedBadge: 'Shared view',
    shortcuts: 'Keyboard shortcuts',
    close: 'Close',
    noteBy: 'Note',
    tour: 'Guided views',
  },

  // Revit files (rvt-rs)
  revit: {
    reading: 'Reading Revit file…',
    converting: 'Converting Revit model to IFC…',
    localHint: 'Converted in your browser: the file is not sent anywhere.',
    unsupportedTitle: 'This Revit file can’t be shown in 3D yet',
    unsupportedDesc: 'Revit {version} {kind}. The 3D view works for Revit 2023, 2024 and 2025 projects.',
    exportHint: 'In Revit: File → Export → IFC, then upload the IFC file here for the full model.',
    download: 'Download original',
    error: 'Could not read this Revit file',
    betaHint: 'Converted from Revit in your browser with rvt-rs. Some elements are simplified (doors, windows and furniture may appear as boxes).',
    kind_project: 'project',
    kind_family: 'family',
    kind_template: 'template',
    kind_unknown: 'file',
  },

  // SEO
  seo: {
    howTitle: 'How it works — upload, view and share BIM files',
    howDesc: 'Drop a Revit, IFC, STEP, DXF or any of 70 3D file types, explore it in the browser and share it with a link or embed. See how Bimdrop works step by step.',
    landingTitle: 'Open and share Revit, IFC, STEP and 3D files with a link',
    landingDesc:
      'Bimdrop opens Revit, IFC, STEP, IGES, Rhino, Tekla, DSTV, DXF, OBJ, FBX, glTF, STL and 70 file types in the browser, with nothing to install. Share them with a link or embed an interactive 3D viewer.',
    pricingTitle: 'Pricing — Free, Pro and Enterprise plans',
    pricingDesc:
      'Simple, transparent pricing for sharing BIM files. Start free with 10 uploads per month. Upgrade to Pro for higher limits, larger files and analytics.',
    legalTitle: 'Legal & Cookie Policy',
    legalDesc:
      'Bimdrop legal notice, terms of service and cookie policy.',
  },
} as const
